import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import TEDER_CONFIG from "./config";

const config = TEDER_CONFIG();

if (config.SentryDSN) {
  Sentry.init({
    dsn: config.SentryDSN,
    integrations: [new BrowserTracing()],
    environment: process.env.NODE_ENV,
    tracesSampleRate: process.env.NODE_ENV === "production" ? 0.2 : 1.0,
    enabled: process.env.NODE_ENV === "production",
  });
}

export default Sentry;
